<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { userService } from '@/http'

import store from '@/store'

import Blogs from '@/Views/Blogs.vue'
import Report from '@/Modals/Report.vue'

const route = useRoute()

const user = ref(null)

const isLoading = ref(false)

const onBlock = () => {
    isLoading.value = true;
    userService.block({
        id: user.value.id
    }).then(res => {
        console.log(res)
        fetchData()
    })
}

const onFriend = () => {
    isLoading.value = true;
    userService.like({
        id: user.value.id
    }).then(res => {
        console.log(res)
        fetchData()
    })
}

const fetchData = () => {
    userService.get({
        id: route.params.user
    }).then(res => {
        user.value = res.data
    })
    isLoading.value = false;
}

onMounted(() => {
    fetchData()
    //console.log(route.params.id)
    
})
</script>

<template>
<div class="user">
    <figure v-if="user.photo" class="user__photo">
        <img 
            :src="$root.$pixel"
            v-lazy="user.photo"
            :alt="user.name"
        />
    </figure>
    <h1 class="user__title">{{ user.name }}</h1>
    <template v-if="!user.block">
        <Modal v-if="!store.isAuth" className="user__send btn btn--full" :auth="true" :callback="() => onFriend()">
            <Icon name="user-plus" /> Добавить в друзья
        </Modal>
        <button v-else class="user__send btn btn--full" :class="{'btn--light': user.like}" @click.prevent="onFriend">
            <template v-if="!user.like">
                <Icon name="user-plus" /> Добавить в друзья
            </template>
            <template v-else>
                <Icon name="user-minus" /> Убрать из друзей
            </template>
        </button>
        <router-link
            v-if="user.like"
            :to="{
                name: 'chat',
                params: {
                    id: user.id
                }
            }"
            class="user__send btn btn--full"
        >
            Написать
        </router-link>
    </template>
    <!-- <div class="user__actions">
        <button class="user__action">
            <Icon name="user-plus" />
        </button>
        <button class="user__action">
            <Icon name="user-minus" />
        </button>
    </div> -->
    
    <div class="user__btns">
        <Modal className="user__btn" title="Жалоба" :auth="true">
            <Icon name="flag" />
            <template #content>
                <Report type="user" :id="user.id" />
            </template>
        </Modal>
        <Modal v-if="!store.isAuth" className="user__btn" :auth="true" :callback="() => onBlock()">
            <Icon name="circle-x" />
        </Modal>
        <button v-else class="user__btn" @click.prevent="onBlock">
            <Icon :name="!user.block ? 'circle-x' : 'circle-check'" />
        </button>
    </div>
</div>
<Blogs class="mt-20" v-if="!user.block" />
<div class="user__block" v-else>
    Заблокировано
</div>
<Loader v-if="isLoading" />
</template>


<style lang="scss">
.user {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    &__title {
        font-size: 24px;
    }
    &__send {
    }

    &__actions {
        display: flex;
        gap: 10px;
        justify-content: space-evenly;
        width: 100%;
    }

    &__action {
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--color-gradient);
        color: #fff;
        border-radius: 50%;
        font-size: 24px;

        &:last-child {
            background: var(--background-primary);
        }
    }
    &__btns {
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
    &__btn {
        font-size: 22px;
        display: flex;
        align-items: center;
        //background: var(--background-primary);
        width: 40px;
        //height: 40px;
        border-radius: 50%;
        justify-content: center;
    }
    &__block {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        padding: 20px;
        background: var(--background-primary);
        border-radius: 8px;
    }
    &__photo {
        width: 150px;
        height: 150px;
    

        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
            border-radius: 50%;
        }
    }
}
</style>